import { baseHomeboundReason } from '../validations/snn';
const shape = baseHomeboundReason.shape;
export const activeConditionsFields = [
    { key: 'activeQualifyingConditions', field: shape.activeQualifyingConditions, variant: 'tags' },
    { key: 'activeQualifyingConditionsOther', field: shape.activeQualifyingConditionsOther },
    { key: 'activeMobilityStatus', field: shape.activeMobilityStatus, variant: 'tags' },
];
export const homeboundStatusFields = [
    { key: 'homeboundStatusThisVisit', field: shape.homeboundStatusThisVisit },
];
export const changeFields = [
    { key: 'whatChanged', field: shape.whatChanged, variant: 'tags' },
    { key: 'dateChangeNoticed', field: shape.dateChangeNoticed, formatDate: true },
    { key: 'triggerEvent', field: shape.triggerEvent },
    { key: 'changeDescription', field: shape.changeDescription },
];
export const dischargeFields = [
    { key: 'lastDayMetCriteria', field: shape.lastDayMetCriteria, formatDate: true },
    { key: 'reasonNoLongerHomebound', field: shape.reasonNoLongerHomebound },
    { key: 'clinicalJustification', field: shape.clinicalJustification },
];
